/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".preview-image[_ngcontent-%COMP%] {\n  cursor: pointer;\n  max-width: 9.375rem;\n  position: relative;\n  height: -webkit-fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  padding: 0.3em; }\n\n.preview-image[_ngcontent-%COMP%]::before {\n  padding-top: 50%; }\n\n.preview-image[_ngcontent-%COMP%]    > img[_ngcontent-%COMP%] {\n  width: 100%;\n  height: auto; }"];
export { styles as styles };
